(() => {
  function mount(section) {
    const gallery = section.querySelector('product-media-mb');
    if (!gallery || gallery.dataset.eqlzThumbsReady === 'true') return;
    gallery.dataset.eqlzThumbsReady = 'true';

    const slideshows = Array.from(gallery.querySelectorAll('slideshow-component'));
    const strips = Array.from(gallery.querySelectorAll('.eqlz-mobile-gallery-thumbs__list'));
    const lastSelected = new WeakMap();

    function keepVisible(strip, button) {
      if (!button || strip.hidden) return;
      const viewport = strip.getBoundingClientRect();
      const selected = button.getBoundingClientRect();
      const inset = 4;
      let displacement = 0;
      if (selected.right > viewport.right - inset) {
        displacement = selected.right - (viewport.right - inset);
      } else if (selected.left < viewport.left + inset) {
        displacement = selected.left - (viewport.left + inset);
      }
      if (Math.abs(displacement) < 1) return;
      const maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
      const target = Math.min(maxScroll, Math.max(0, strip.scrollLeft + displacement));
      if (Math.abs(target - strip.scrollLeft) < 1) return;
      strip.scrollTo({ left: target, behavior: 'auto' });
    }

    function getIndex(slideshow) {
      const slider = slideshow.querySelector('.slideshow.slider');
      const slides = Array.from(slideshow.querySelectorAll('.slideshow__slide'));
      if (!slider || !slides.length) return 0;
      const distance = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slider.clientWidth;
      if (!(distance > 0)) return Math.max(0, (slideshow.currentPage || 1) - 1);
      return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / distance)));
    }

    function updateOne(index) {
      const slideshow = slideshows[index];
      const strip = strips[index];
      if (!slideshow || !strip || strip.hidden) return;
      const activeIndex = getIndex(slideshow);
      const buttons = Array.from(strip.querySelectorAll('button[data-slide-index]'));
      let activeButton;
      buttons.forEach(button => {
        const selected = Number(button.dataset.slideIndex) === activeIndex;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        if (selected) activeButton = button;
      });
      if (lastSelected.get(strip) !== activeIndex || (activeButton && (activeButton.getBoundingClientRect().right > strip.getBoundingClientRect().right - 3 || activeButton.getBoundingClientRect().left < strip.getBoundingClientRect().left + 3))) {
        lastSelected.set(strip, activeIndex);
        keepVisible(strip, activeButton);
      }
    }

    function updateVisibility() {
      slideshows.forEach((slideshow, index) => {
        const strip = strips[index];
        if (!strip) return;
        const visible = slideshow.style.display !== 'none' && getComputedStyle(slideshow).display !== 'none';
        strip.hidden = !visible;
        if (visible) updateOne(index);
      });
    }

    slideshows.forEach((slideshow, index) => {
      const slider = slideshow.querySelector('.slideshow.slider');
      let pending = false;
      slideshow.addEventListener('slideChanged', () => updateOne(index));
      slider?.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          updateOne(index);
        });
      }, { passive: true });
    });

    gallery.addEventListener('click', event => {
      const button = event.target.closest('button.eqlz-mobile-gallery-thumbs__button');
      if (!button || !gallery.contains(button)) return;
      const strip = button.closest('.eqlz-mobile-gallery-thumbs__list');
      const index = strips.indexOf(strip);
      const slideshow = slideshows[index];
      const slider = slideshow?.querySelector('.slideshow.slider');
      const slides = Array.from(slideshow?.querySelectorAll('.slideshow__slide') || []);
      const targetIndex = Number(button.dataset.slideIndex);
      if (!slider || !slides[targetIndex]) return;
      const position = slides[targetIndex].offsetLeft - slides[0].offsetLeft;
      slider.scrollTo({ left: position, behavior: 'smooth' });
      keepVisible(strip, button);
      requestAnimationFrame(() => keepVisible(strip, button));
      strip.querySelectorAll('button[data-slide-index]').forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      lastSelected.set(strip, targetIndex);
    });

    const observer = new MutationObserver(updateVisibility);
    slideshows.forEach(slideshow => observer.observe(slideshow, { attributes: true, attributeFilter: ['style'] }));
    updateVisibility();
  }

  function init(root = document) {
    root.querySelectorAll('section[id^="MainProduct-"]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();